module.exports = __webpack_public_path__ + "img/ic-triangle-dn.d6491489.svg";